import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'solar-battery-storage-installation-sydney';
const serviceId = 3
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Solar Battery Storage Installation Sydney  | ${BUSINESS_NAME}`,
        description: "Maximise solar savings with battery backup systems. Store excess energy and enjoy reliable power even during blackouts or peak tariff times.",
        keywords: "solar battery storage installation Sydney, solar battery systems, home battery backup, energy storage solutions, solar power storage, residential battery installation, commercial battery systems, off-grid solar solutions, solar energy management, sustainable energy storage",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Solar Battery Storage Installation',
    description: 'Maximise solar savings with battery backup systems. Store excess energy and enjoy reliable power even during blackouts or peak tariff times.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
